import React, { FC } from 'react';
import { FieldConfig, Field } from 'formik';
import { typeHelpers } from '@polymathnetwork/new-shared';
import { Context } from '../Context';

export interface Props
  extends typeHelpers.Omit<FieldConfig, 'name' | 'component'> {
  FormikComponent: React.ComponentType<FieldConfig>;
  placeholder?: string;
  component: React.ComponentType<any>;
  inputProps?: { [key: string]: any };
  onChange?: (value: any) => void;
}

export const InputBase: FC<Props> = ({
  FormikComponent,
  component,
  inputProps,
  children,
  onChange,
  validate,
  innerRef,
  ...props
}: Props) => {
  const Component = component;

  return (
    <Context.Consumer>
      {({ name }) => (
        <FormikComponent
          name={name}
          validate={validate}
          innerRef={innerRef}
          render={formikProps => (
            <Component
              {...formikProps}
              {...inputProps}
              {...props}
              onChange={onChange}
            >
              {children}
            </Component>
          )}
        />
      )}
    </Context.Consumer>
  );
};

export const Input = Object.assign(InputBase, {
  defaultProps: {
    // FIXME @RafaelVidaurre: This prop is unusable, the form breaks
    // Switched to Field component as a safer default
    FormikComponent: Field,
  },
});
try {
    // @ts-ignore
    InputBase.displayName = "InputBase";
    // @ts-ignore
    InputBase.__docgenInfo = { "description": "", "displayName": "InputBase", "props": { "FormikComponent": { "defaultValue": null, "description": "", "name": "FormikComponent", "required": true, "type": { "name": "any" } }, "placeholder": { "defaultValue": null, "description": "", "name": "placeholder", "required": false, "type": { "name": "string" } }, "component": { "defaultValue": null, "description": "", "name": "component", "required": true, "type": { "name": "any" } }, "inputProps": { "defaultValue": null, "description": "", "name": "inputProps", "required": false, "type": { "name": "{ [key: string]: any; }" } }, "onChange": { "defaultValue": null, "description": "", "name": "onChange", "required": false, "type": { "name": "(value: any) => void" } }, "render": { "defaultValue": null, "description": "", "name": "render", "required": false, "type": { "name": "(props: FieldProps<any>) => ReactNode" } }, "validate": { "defaultValue": null, "description": "", "name": "validate", "required": false, "type": { "name": "(value: any) => string | Promise<void>" } }, "type": { "defaultValue": null, "description": "", "name": "type", "required": false, "type": { "name": "string" } }, "value": { "defaultValue": null, "description": "", "name": "value", "required": false, "type": { "name": "any" } }, "innerRef": { "defaultValue": null, "description": "", "name": "innerRef", "required": false, "type": { "name": "(instance: any) => void" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/FormItem/Input/index.tsx#InputBase"] = { docgenInfo: InputBase.__docgenInfo, name: "InputBase", path: "src/components/FormItem/Input/index.tsx#InputBase" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    Input.displayName = "Input";
    // @ts-ignore
    Input.__docgenInfo = { "description": "", "displayName": "Input", "props": { "FormikComponent": { "defaultValue": null, "description": "", "name": "FormikComponent", "required": true, "type": { "name": "any" } }, "placeholder": { "defaultValue": null, "description": "", "name": "placeholder", "required": false, "type": { "name": "string" } }, "component": { "defaultValue": null, "description": "", "name": "component", "required": true, "type": { "name": "any" } }, "inputProps": { "defaultValue": null, "description": "", "name": "inputProps", "required": false, "type": { "name": "{ [key: string]: any; }" } }, "onChange": { "defaultValue": null, "description": "", "name": "onChange", "required": false, "type": { "name": "(value: any) => void" } }, "render": { "defaultValue": null, "description": "", "name": "render", "required": false, "type": { "name": "(props: FieldProps<any>) => ReactNode" } }, "validate": { "defaultValue": null, "description": "", "name": "validate", "required": false, "type": { "name": "(value: any) => string | Promise<void>" } }, "type": { "defaultValue": null, "description": "", "name": "type", "required": false, "type": { "name": "string" } }, "value": { "defaultValue": null, "description": "", "name": "value", "required": false, "type": { "name": "any" } }, "innerRef": { "defaultValue": null, "description": "", "name": "innerRef", "required": false, "type": { "name": "(instance: any) => void" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/FormItem/Input/index.tsx#Input"] = { docgenInfo: Input.__docgenInfo, name: "Input", path: "src/components/FormItem/Input/index.tsx#Input" };
}
catch (__react_docgen_typescript_loader_error) { }